<template>
    <div>
        <nuxt />
        <PortalTarget name="modal" />
    </div>
</template>

<script>
export default {
    loading: false,
};
</script>
